import React from 'react';
import _map from 'lodash/map';
import { Select, useSelect } from '@econsult/econsult-ui/dist/components/Select';
import { ChevronIcon } from '@econsult/econsult-ui/dist/assets';
import { STRINGS } from 'config';
import { Option, SelectOptions, SelectButton, Tick } from 'components/Form/Select';

const { PRACTICE: { CONSULTATION_RESPONSE_TIME_DAYS } } = STRINGS;

export const ConsultationResponseDaysSelect = ({ responseTimeInDays, onClickResponseDays }) => {
  const { toggleSelect, selectContext } = useSelect();
  const handleClickResponseTime = _responseTimeInDays => event => {
    onClickResponseDays(_responseTimeInDays);
    event.preventDefault();
  };
  return (
    <Select closeOnClickOutside selectContext={selectContext} automationName="CRTDropdown" theme="light">
      <SelectButton onClick={toggleSelect} type="button" data-automation="CRTDropdownButton" value={responseTimeInDays} name="responseTimeInDays">
        <span>{CONSULTATION_RESPONSE_TIME_DAYS[responseTimeInDays]}</span>
        <ChevronIcon />
      </SelectButton>
      <SelectOptions automationName="CRTDropdownOptions">
        {_map(CONSULTATION_RESPONSE_TIME_DAYS, (responseTimeDisplayName, _responseTimeInDays) => (
          <Option key={_responseTimeInDays} onClick={handleClickResponseTime(_responseTimeInDays)} data-automation={`CRTOption-${_responseTimeInDays}`}>
            <span>{responseTimeDisplayName}</span>
            <Tick automationName="SelectedCRTIndicator" isVisible={responseTimeInDays === _responseTimeInDays} />
          </Option>
        ))}
      </SelectOptions>
    </Select>
  );
};
